export default {
  menu: "メニュー",
  tickets: "切符売場",
  speakers: "スピーカー",
  schedule: "スケジュール",
  venue: "会場",
  attendees: "出席者",
  contact: "接触",
  tech_ethics: "テック：\n道徳",
  about_intro:
    "11月24日と25日には、今日の人工知能に関する最も重要な倫理トピックを扱う12の業界をリードするスピーカーとの単一トラック会議であるTECH:ETHICSの年次会議が東京で開催されています。",
  about_date: "11/24/2018 - 11/25/2018",
  about_location_1: "Makuhari Messe",
  about_location_2: "2-1, Nakase, Mihama-ku, Chiba-city, 261-8550 Japan",
  contact_1:
    "テック：道徳 技術会議で運営されています。 レイチェル・サン、ライク・ヴァン・ザンテン、ジェイコブ・ヘフトマンが含まれる。",
  contact_2: "でフォローします",
  contact_3: "Twitter",
  contact_4: "私たちのメーリングリストに登録する",
  contact_5: "将来のアップデートのために。",
  contact_6:
    "一般的な、またはスポンサーシップの質問については、Rachel Sunにお問い合わせください。 202-555-0152",
  contact_7:
    "管理上の質問については、Rijk van Zantenにお問い合わせください。 202-555-0187",
  times: {
    1: "08:15",
    2: "09:00",
    3: "09:50",
    4: "10:40",
    5: "11:10",
    6: "12:00",
    7: "12:50",
    8: "13:50",
    9: "14:40",
    10: "15:30",
    11: "16:00",
    12: "16:50",
    13: "17:40"
  },
  titles: {
    doors: "ドアを開く",
    opening: "朝食、コーヒー＆登録",
    break: "ブレーク",
    drinks: "ドリンクとディスカッション",
    lunch: "ランチ",
    afterparty: "アフターパーティー",
    1: "ブロックチェーンエネルギーを無駄にする",
    2: "スマートフォンのまれな資料",
    3: "社会的コミュニケーションにおける匿名性：問題",
    4: "プライバシーと利便性",
    5: "無料サービス - データで支払う",
    6: "自律車による死亡",
    7: "親は乳児の遺伝子を編集できなければなりませんか？",
    8: "プライバシーはどれくらいですか？",
    9: "3D印刷武器",
    10: "話す（録音）Barbie",
    11: "企業が収集できるデータ量はどれくらいですか？",
    12: "オンラインビデオゲームにおける暴力",
    13: "バーチャルワールドでの適応",
    14: "ロボットが私たちの仕事を引き継ぐのだろうか？",
    15: "Second Machine Age：それは本当に私たちを助けてくれるのですか？"
  },
  tickets_1:
    "早期鳥の登録は695ドルで、最初の100枚または11月20日に限定されています！",
  tickets_2: "ワークショップチケットは含まれていません。",
  tickets_3: "チケットを入手する",
  day1: "1日目",
  day2: "2日目"
};
